import React, { useState, useContext, useEffect } from 'react'
import { Button, Card, ListGroup, Modal, Spinner } from 'react-bootstrap';
import { FiUser, FiPhone, FiMapPin, FiClock, FiCheck, FiX, FiDollarSign, FiArrowRight } from 'react-icons/fi';
import { FaBus } from 'react-icons/fa';
import TripCollectingModal from './TripCollectingModal';
import moment from 'moment'
import { NotificationManager } from 'react-notifications'

import { AppContext } from '../AppContext';
import { tre } from '../trebus'

export default function TravellerList({ idStart, travList, onChange, onConfirm, stopName }) {

    const context = useContext(AppContext);
    const [showSelectReturn, setShowSelectReturn] = useState(false);
    const [travellerReturn, setTravellerReturn] = useState();
    const [showCollectingModal, setShowCollectingModal] = useState(false);
    const [selectedTraveller, setSelectedTraveller] = useState(null);
    const [confirmingId, setConfirmingId] = useState(null);

    const confirm = (traveller) => {
        const newConfirmed = traveller.confirmed ? 0 : 1;
        setConfirmingId(traveller.id);
        tre.api('PUT', '/travellers/' + traveller.id, {
            context: context,
            params: { confirmed: newConfirmed },
            success: () => {
                setConfirmingId(null);
                if (onConfirm) {
                    onConfirm(traveller.id, newConfirmed);
                } else {
                    onChange();
                }
            },
            error: () => setConfirmingId(null)
        });
    }

    const openSelectReturn = (traveller) => {
        setTravellerReturn(traveller)
        setShowSelectReturn(true);
    }

    const filteredTravellers = travList?.filter(t =>
        (t.start_id === parseInt(idStart)) || !idStart
    ) || [];

    return (
        <div>
            {/* Header with stop name */}
            <Card className="border-0 mb-4" style={{ borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                <Card.Header
                    className="py-3 px-4"
                    style={{
                        backgroundColor: '#f8f9fa',
                        borderBottom: '1px solid #e9ecef',
                        borderRadius: '12px 12px 0 0'
                    }}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div
                                className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                style={{ width: '40px', height: '40px', backgroundColor: '#e8f0fe' }}
                            >
                                <FiMapPin style={{ color: '#1a73e8' }} size={20} />
                            </div>
                            <h6 className="mb-0" style={{ color: '#202124', fontWeight: 500 }}>
                                {stopName || 'Pasajeros'}
                            </h6>
                        </div>
                        <span
                            style={{
                                backgroundColor: '#e8f0fe',
                                color: '#1a73e8',
                                padding: '8px 14px',
                                borderRadius: '20px',
                                fontSize: '0.9rem',
                                fontWeight: 500
                            }}
                        >
                            {filteredTravellers.length} pasajeros
                        </span>
                    </div>
                </Card.Header>
                <Card.Body className="p-0">
                    {filteredTravellers.length > 0 ? (
                        <div className="p-3">
                            {filteredTravellers.map(traveller => (
                                <Card
                                    key={traveller.id}
                                    className="mb-3 border-0"
                                    style={{
                                        borderRadius: '12px',
                                        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                                        borderLeft: traveller.confirmed
                                            ? '4px solid #34a853'
                                            : '4px solid #e9ecef'
                                    }}
                                >
                                    <Card.Body className="p-4">
                                        {/* Traveller Header */}
                                        <div className="d-flex align-items-start justify-content-between mb-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        backgroundColor: traveller.confirmed ? '#e6f4ea' : '#e8f0fe',
                                                        color: traveller.confirmed ? '#34a853' : '#1a73e8',
                                                        fontSize: '1.2rem',
                                                        fontWeight: 600
                                                    }}
                                                >
                                                    {(traveller.user?.name || '?').charAt(0).toUpperCase()}
                                                </div>
                                                <div>
                                                    <h5 className="mb-1" style={{ color: '#202124', fontWeight: 500 }}>
                                                        {traveller.user?.full_name}
                                                    </h5>
                                                    {traveller.user?.mobile && (
                                                        <span className="d-flex align-items-center" style={{ color: '#5f6368' }}>
                                                            <FiPhone className="me-2" size={14} />
                                                            {traveller.user.mobile}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            {!!traveller.confirmed && (
                                                <span
                                                    className="d-flex align-items-center"
                                                    style={{
                                                        backgroundColor: '#e6f4ea',
                                                        color: '#34a853',
                                                        padding: '8px 14px',
                                                        borderRadius: '20px',
                                                        fontSize: '0.8rem',
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    <FiCheck className="me-1" />
                                                    CONFIRMADO
                                                </span>
                                            )}
                                        </div>

                                        {/* Trip Details */}
                                        <div
                                            className="p-3 mb-3"
                                            style={{
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '10px'
                                            }}
                                        >
                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                                            style={{ width: '32px', height: '32px', backgroundColor: '#e8f0fe' }}
                                                        >
                                                            <FiArrowRight style={{ color: '#1a73e8' }} />
                                                        </div>
                                                        <div>
                                                            <small style={{ color: '#5f6368' }} className="d-block">Ida</small>
                                                            <strong style={{ color: '#202124' }}>{traveller.start?.name}</strong>
                                                            <span className="ms-2" style={{ color: '#5f6368' }}>
                                                                {traveller.trip?.route && moment(traveller.trip.route.departure, 'HH:mm:ss').format('H:mm')}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                                            style={{ width: '32px', height: '32px', backgroundColor: '#e6f4ea' }}
                                                        >
                                                            <FiArrowRight style={{ color: '#34a853', transform: 'rotate(180deg)' }} />
                                                        </div>
                                                        <div>
                                                            <small style={{ color: '#5f6368' }} className="d-block">Vuelta</small>
                                                            {traveller.traveller_return ? (
                                                                <>
                                                                    <strong style={{ color: '#202124' }}>{traveller.traveller_return.start?.name}</strong>
                                                                    <span className="ms-2" style={{ color: '#5f6368' }}>
                                                                        {moment(traveller.traveller_return.trip?.route?.departure, 'HH:mm:ss').format('H:mm')}
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <span style={{ color: '#5f6368' }}>No seleccionada</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Price */}
                                            {traveller.rate && (
                                                <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e9ecef' }}>
                                                    <div className="d-flex align-items-center">
                                                        <FiDollarSign className="me-2" style={{ color: '#1a73e8' }} />
                                                        <span style={{ color: '#5f6368' }} className="me-2">Importe:</span>
                                                        <strong style={{ color: '#1a73e8', fontSize: '1.1rem' }}>
                                                            {(traveller.rate?.price || 0) +
                                                                (traveller.traveller_return?.rate?.price || 0)} €
                                                        </strong>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="d-flex flex-wrap gap-2">
                                            {!traveller.traveller_return &&
                                             traveller.trip?.route?.direction === 'GO' && (
                                                <Button
                                                    onClick={() => openSelectReturn(traveller)}
                                                    style={{
                                                        backgroundColor: '#1a73e8',
                                                        border: 'none',
                                                        borderRadius: '8px',
                                                        padding: '8px 16px',
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    <FiClock className="me-2" />
                                                    Seleccionar vuelta
                                                </Button>
                                            )}
                                            <Button
                                                onClick={() => confirm(traveller)}
                                                disabled={confirmingId === traveller.id}
                                                variant={traveller.confirmed ? 'light' : undefined}
                                                style={{
                                                    backgroundColor: traveller.confirmed ? undefined : '#34a853',
                                                    border: traveller.confirmed ? '1px solid #dadce0' : 'none',
                                                    borderRadius: '8px',
                                                    padding: '8px 16px',
                                                    color: traveller.confirmed ? '#5f6368' : '#fff',
                                                    fontWeight: 500
                                                }}
                                            >
                                                {confirmingId === traveller.id ? (
                                                    <>
                                                        <Spinner size="sm" className="me-2" />
                                                        {traveller.confirmed ? 'Deshaciendo...' : 'Confirmando...'}
                                                    </>
                                                ) : traveller.confirmed ? (
                                                    <>
                                                        <FiX className="me-2" />
                                                        Deshacer
                                                    </>
                                                ) : (
                                                    <>
                                                        <FiCheck className="me-2" />
                                                        Confirmar
                                                    </>
                                                )}
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    setSelectedTraveller(traveller);
                                                    setShowCollectingModal(true);
                                                }}
                                                variant="light"
                                                style={{
                                                    border: '1px solid #34a853',
                                                    borderRadius: '8px',
                                                    padding: '8px 16px',
                                                    color: '#34a853',
                                                    fontWeight: 500
                                                }}
                                            >
                                                <FiDollarSign className="me-2" />
                                                Cobrar
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{ width: '80px', height: '80px', backgroundColor: '#f8f9fa' }}
                            >
                                <FiUser size={36} style={{ color: '#dadce0' }} />
                            </div>
                            <p className="text-muted mb-0">Sin pasajeros en esta parada</p>
                        </div>
                    )}
                </Card.Body>
            </Card>

            <SelectReturn
                traveller={travellerReturn}
                show={showSelectReturn}
                toggle={() => setShowSelectReturn(!showSelectReturn)}
                onChange={onChange}
            />
            <TripCollectingModal
                show={showCollectingModal}
                handleClose={() => {
                    setShowCollectingModal(false);
                    setSelectedTraveller(null);
                }}
                traveller={selectedTraveller}
            />
        </div>
    );
}


/**
 * Modal to select return trip
 */
function SelectReturn({ traveller, show, toggle, onChange }) {

    const context = useContext(AppContext);
    const [tripsReturn, setTripsReturn] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const loadTripsReturn = () => {
        setIsLoading(true);
        tre.api('GET', '/trips/journeys', {
            context: context,
            params: {
                date: traveller.trip.date,
            },
            success: (r) => {
                setTripsReturn(r);
                setIsLoading(false);
            },
            error: () => setIsLoading(false)
        });
    }

    useEffect(() => {
        if (traveller) loadTripsReturn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [traveller]);

    const addReturn = (tripReturn) => {
        tre.api('POST', '/trips/' + tripReturn.id + '/users/' + traveller.user.id, {
            context: context,
            params: {
                idTravellerGo: traveller.id
            },
            success: () => {
                NotificationManager.success(`Añadido el usuario ${traveller.user.name} al viaje`);
                toggle();
                onChange();
            }
        });
    }

    return (
        <Modal show={show} onHide={toggle} centered>
            <Modal.Header
                closeButton
                style={{
                    backgroundColor: '#f8f9fa',
                    borderBottom: '1px solid #e9ecef'
                }}
            >
                <Modal.Title className="d-flex align-items-center" style={{ color: '#202124', fontWeight: 500 }}>
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle me-3"
                        style={{ width: '40px', height: '40px', backgroundColor: '#e6f4ea', color: '#34a853' }}
                    >
                        <FiClock size={18} />
                    </div>
                    Seleccionar Vuelta
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                {isLoading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" style={{ color: '#1a73e8' }} />
                        <p className="mt-3 text-muted">Cargando viajes...</p>
                    </div>
                ) : (
                    <ListGroup style={{ borderRadius: '12px', overflow: 'hidden' }}>
                        {tripsReturn.map(trip => {
                            if (trip.route.direction === 'COME') {
                                return (
                                    <ListGroup.Item
                                        key={trip.id}
                                        action
                                        onClick={() => addReturn(trip)}
                                        className="py-3 px-4"
                                        style={{
                                            borderLeft: '3px solid transparent',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.borderLeftColor = '#34a853'}
                                        onMouseLeave={(e) => e.currentTarget.style.borderLeftColor = 'transparent'}
                                    >
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                                    style={{
                                                        width: '36px',
                                                        height: '36px',
                                                        backgroundColor: '#e6f4ea',
                                                        color: '#34a853'
                                                    }}
                                                >
                                                    <FaBus size={16} />
                                                </div>
                                                <span style={{ fontWeight: 500, color: '#202124' }}>{trip.route.name}</span>
                                            </div>
                                            <span
                                                style={{
                                                    backgroundColor: '#e6f4ea',
                                                    color: '#34a853',
                                                    padding: '6px 12px',
                                                    borderRadius: '8px',
                                                    fontWeight: 500
                                                }}
                                            >
                                                {moment(trip.route.departure, 'HH:mm').format('HH:mm')}
                                            </span>
                                        </div>
                                    </ListGroup.Item>
                                );
                            }
                            return null;
                        })}
                    </ListGroup>
                )}
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #e9ecef' }}>
                <Button
                    variant="light"
                    onClick={toggle}
                    style={{ borderRadius: '8px', fontWeight: 500 }}
                >
                    <FiX className="me-2" />
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
